import * as Yup from "yup";
import removeMd from "remove-markdown";

Yup.addMethod(Yup.string, "stripMarkdown", function() {
  return this.transform(function(value, originalValue) {
    return removeMd(originalValue);
  });
});
